import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './loader.css';

const Loader = (props) => {
  const setting = useSelector(state => state.setting);
  const [logoLoaded, setLogoLoaded] = useState(false);
  
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    setLogoLoaded(false);
  };

  const handleImageLoad = () => {
    setLogoLoaded(true);
  };

  return (
    <>
      {props.screen !== undefined && props.screen === 'full'
        ? (
          <div className={`modern-loader-full-screen loader-container`} style={props.background === 'none' ? { background: "none" } : {}} role="status" aria-live="polite" aria-label="جاري التحميل">
            <div className="modern-loader-content">
              {/* شعار الموقع مع تأثيرات */}
              <div className="logo-container">
                <div className="logo-wrapper">
                  {setting?.setting?.web_settings?.web_logo ? (
                    <>
                      <img 
                        src={setting.setting.web_settings.web_logo} 
                        alt="البيت الشامل" 
                        className={`loading-logo ${logoLoaded ? 'loaded' : ''}`}
                        onError={handleImageError}
                        onLoad={handleImageLoad}
                      />
                      {!logoLoaded && (
                        <div className="logo-loading-placeholder">
                          <div className="placeholder-spinner"></div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="logo-fallback">
                      <i className="fas fa-store"></i>
                      <span>البيت الشامل</span>
                    </div>
                  )}
                </div>
                <div className="pulse-rings">
                  <div className="pulse-ring"></div>
                  <div className="pulse-ring"></div>
                  <div className="pulse-ring"></div>
                </div>
              </div>
              
              {/* شريط التحميل */}
              <div className="loading-progress" aria-label="شريط التقدم">
                <div className="progress-bar" role="progressbar" aria-label="تقدم التحميل">
                  <div className="progress-fill"></div>
                </div>
                <div className="loading-dots" aria-hidden="true">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
              </div>
              
              {/* النص */}
              <div className="loading-text">
                <h3 aria-live="polite">{props.content ? props.content : 'جاري التحميل...'}</h3>
                <p>{setting?.setting?.web_settings?.web_name ? `مرحباً بك في ${setting.setting.web_settings.web_name}` : 'أفضل المنتجات في انتظارك'}</p>
              </div>
              
              {/* Hidden text for screen readers */}
              <div className="sr-only" aria-live="polite" aria-atomic="true">
                يتم الآن تحميل الصفحة، يرجى الانتظار
              </div>
            </div>
          </div>
        )
        : (
          <div className={`mini-loader-container`} style={props.background !== undefined
            ? props.width !== undefined && props.height !== undefined
              ? { width: props.width, height: props.height, background: props.background }
              : { background: props.background }
            : props.width !== undefined && props.height !== undefined
              ? { width: props.width, height: props.height }
              : {}} role="status" aria-label="تحميل">
            <div className="mini-loader-box">
              <div className="mini-spinner">
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export default Loader;
